import axios2 from '../api/axios';
export const settingservices = {
    addsubscription,
    getsubscription,
    getsubscriptionpperm,
    addsubscriptionperm,
    getsettingsData 
}

function addsubscription(objdata){
    return axios2.post('/addsubscription',objdata,(response) =>{
           return response;
    }).catch((error)=>{
         console.log(error);
    });   
}

function getsubscription(){
    return axios2.get('/getsubscription',(response) =>{
           return response;
    }).catch((error)=>{
         console.log(error);
    });   
}

function getsubscriptionpperm(){
    return axios2.get('/getsubscriptionperm',(response) =>{
        return response;
    }).catch((error)=>{
        console.log(error);
    });   
}

function addsubscriptionperm(objdata){
    return axios2.post('/addsubscriptionperm',objdata,(response) =>{
        return response;
    }).catch((error)=>{
        console.log(error);
    });
}


function getsettingsData(){
    return axios2.get('/getSettings',(response) =>{
        return response;
    }).catch((error)=>{
        console.log(error);
    });
}

